import * as React from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";

interface AlertProps {
  severity: "success" | "info" | "warning" | "error";
}

const DescriptionAlerts: React.FC<AlertProps & { uploadSuccess: boolean }> = ({
  severity,
  uploadSuccess,
}) => {
  return (
    <Stack
      sx={{ width: "100%", alignItems: "center", marginTop: "3%" }}
      spacing={2}
    >
      {severity === "success" && (
        <Alert
          className="alert-transition"
          style={{ backgroundColor: "whiteSmoke", borderRadius: "11px" }}
          severity={severity}
        >
          <AlertTitle>
            {uploadSuccess ? "Upload Success" : "Success"}
          </AlertTitle>
          {uploadSuccess
            ? "File uploaded successfully!"
            : "Thank you for your feedback. Your message has been delivered and will be taken over by the nexbot team."}
        </Alert>
      )}
      {severity === "error" && (
        <Alert
          style={{ backgroundColor: "whiteSmoke", borderRadius: "11px" }}
          severity="error"
        >
          <AlertTitle>Error</AlertTitle>
          {uploadSuccess
            ? "Error uploading file. Please try again."
            : "Something gone wrong, try again in couple of minutes!"}
        </Alert>
      )}
    </Stack>
  );
};

export default DescriptionAlerts;
